import axios, { AxiosInstance } from 'axios';

import { addMaintenanceRedirectInterceptor } from '../utils/maintenanceRedirect';

export const SUBMIT_REQUEST_TIMEOUT_MS = 30000;

export const callSubmit = async (url: string, submitBundle: any) => {
  const axiosInstance = getInstance();
  const { data } = await axiosInstance.post(url, toBody(submitBundle), {
    timeout: SUBMIT_REQUEST_TIMEOUT_MS,
  });

  return data;
};

const getInstance = (): AxiosInstance => {
  const ret = axios.create();

  ret.defaults.headers.post['Content-Type'] =
    'application/x-www-form-urlencoded';
  addMaintenanceRedirectInterceptor(ret);

  return ret;
};

const toBody = (args: any): string => {
  return new URLSearchParams(args as Record<string, string>).toString();
};
